import { BitfNetPathBuilder } from '@common/libs/bitforce/core/parsers/net-parser';

export class AppPathBuilder extends BitfNetPathBuilder {}
